module.exports = __webpack_public_path__ + "img/email.2e21de89.svg";